import script from "./WishlistLogin.vue?vue&type=script&lang=ts&setup=true"
export * from "./WishlistLogin.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__